import { Link } from "react-scroll";
import profileImage from "../../assets/Nikola.png";
import "./Navbar.style.css";
// icons
import {
  AiFillLinkedin,
  AiFillGithub,
  AiOutlineHome,
  AiOutlineUser,
  AiOutlineMail,
} from "react-icons/ai";
import { GiHamburgerMenu } from "react-icons/gi";

import { HiOutlineDocumentText } from "react-icons/hi";
import { RiBookReadLine } from "react-icons/ri";
import { useState } from "react";

const Navbar = () => {
  const [toggle, setToggle] = useState(false);
  return (
    <>
      {/* Navbar web */}
      <div id="navbar-web">
        <div className="navbar-container">
          <div className="profile">
            <img src={profileImage} alt="profle-img" />
            <p className="fullName">Nikola Ristoski</p>
            <ul className="ul-social">
              <li>
                <a href="https://www.linkedin.com/in/nikola-ristoski/">
                  <AiFillLinkedin />
                </a>
              </li>
              <li>
                <a href="https://github.com/Nikola0707">
                  <AiFillGithub />
                </a>
              </li>
            </ul>
          </div>
          <div className="nav-container">
            <ul>
              <li>
                <Link
                  activeClass="active"
                  to="home"
                  spy={true}
                  smooth={true}
                  duration={1500}
                >
                  <AiOutlineHome />
                  <span>Home</span>
                </Link>
              </li>
              <li>
                <Link
                  activeClass="active"
                  to="about"
                  spy={true}
                  smooth={true}
                  duration={1500}
                >
                  <AiOutlineUser />
                  <span>About</span>
                </Link>
              </li>
              <li>
                <Link
                  activeClass="active"
                  to="resume"
                  spy={true}
                  smooth={true}
                  duration={1500}
                >
                  <HiOutlineDocumentText />
                  <span>Resume</span>
                </Link>
              </li>
              <li>
                <Link
                  activeClass="active"
                  to="projects"
                  spy={true}
                  smooth={true}
                  duration={1500}
                >
                  <RiBookReadLine />
                  <span>Portfolio</span>
                </Link>
              </li>
              <li>
                <Link
                  activeClass="active"
                  to="contact"
                  spy={true}
                  smooth={true}
                  duration={1500}
                >
                  <AiOutlineMail />
                  <span>Contact</span>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      {/* Navbar Mobile */}

      {toggle ? (
        <div id="navbar-mobile">
          <div className="hamburger-menu">
            <GiHamburgerMenu onClick={() => setToggle(!toggle)} />
          </div>
          <div className="navbar-container">
            <div className="profile">
              <img src={profileImage} alt="profle-img" />
              <p className="fullName">Nikola Ristoski</p>
              <ul className="ul-social">
                <li>
                  <a href="https://www.linkedin.com/in/nikola-ristoski/">
                    <AiFillLinkedin />
                  </a>
                </li>
                <li>
                  <a href="https://github.com/Nikola0707">
                    <AiFillGithub />
                  </a>
                </li>
              </ul>
            </div>
            <div className="nav-container">
              <ul>
                <li>
                  <Link
                    activeClass="active"
                    to="home"
                    spy={true}
                    smooth={true}
                    duration={1500}
                    onClick={() => setToggle(!toggle)} 
                  >
                    <AiOutlineHome />
                    <span>Home</span>
                  </Link>
                </li>
                <li>
                  <Link
                    activeClass="active"
                    to="about"
                    spy={true}
                    smooth={true}
                    duration={1500}
                    onClick={() => setToggle(!toggle)} 
                  >
                    <AiOutlineUser />
                    <span>About</span>
                  </Link>
                </li>
                <li>
                  <Link
                    activeClass="active"
                    to="resume"
                    spy={true}
                    smooth={true}
                    duration={1500}
                    onClick={() => setToggle(!toggle)} 
                  >
                    <HiOutlineDocumentText />
                    <span>Resume</span>
                  </Link>
                </li>
                <li>
                  <Link
                    activeClass="active"
                    to="projects"
                    spy={true}
                    smooth={true}
                    duration={1500}
                    onClick={() => setToggle(!toggle)} 
                  >
                    <RiBookReadLine />
                    <span>Portfolio</span>
                  </Link>
                </li>
                <li>
                  <Link
                    activeClass="active"
                    to="contact"
                    spy={true}
                    smooth={true}
                    duration={1500}
                    onClick={() => setToggle(!toggle)} 
                  >
                    <AiOutlineMail />
                    <span>Contact</span>
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      ) : (
        <div id="navbar-mobile">
          <div className="hamburger-menu">
            <GiHamburgerMenu onClick={() => setToggle(!toggle)} />
          </div>
        </div>
      )}
    </>
  );
};

export default Navbar;
